import React, { ReactNode, useContext } from 'react'

import styles from './index.module.css'
import { CardContext, CardVariant, ICardContext } from '..'
import { BreakpointSizes, useBrowser } from '@s4l/utils/hooks/useBrowser'

export interface IBodyProps {
  children: ReactNode
  variant?: CardVariant
}

function Body(props: IBodyProps) {
  const { children, variant } = props

  const { url, Link, onClick } = useContext<ICardContext>(CardContext)

  const { activeBreakpoint } = useBrowser()

  return (
    <Link
      className={styles.container}
      href={url}
      target={activeBreakpoint >= BreakpointSizes.L ? '_blank' : '_self'}
      data-variant={variant}
      data-testid="card-body"
      onClick={onClick}
    >
      {children}
    </Link>
  )
}

Body.displayName = 'Card.Body'

export { Body }
